import type { News, NewsAndContent } from "@/api/news/types";
import { useGet } from "@/api/lib/integration";
import { newsResponseSchema, newsShowResponseSchema } from "@/api/news/zod";

export const getNews = useGet<{  id: number }, NewsAndContent>('/api/hinweise/{id}', { schema: newsShowResponseSchema });
export const getAllNews = useGet<void, News[]>('/api/hinweise', { schema: newsResponseSchema });
